module.exports = __webpack_public_path__ + "static/media/cleaning after work.6ad8d53b.png";